<template>
  <b-form-group
    :id="id + 'group'"
    :label-for="id"
    :state="state"
    :invalid-feedback="invalidFeedback"
    :description="description"
    :label-cols-sm="labelCols"
    :label-align-sm="labelAlign"
    content-cols-sm="9"
    :class="'cp-textfield cp-fieldlabel item ' + requiredClass"

  >
    <template #label>
      {{ (label)? label : $t('LABEL.' + fieldname) }}
    </template>
    <div v-if="viewmode">
      <h5>
        <b-badge variant="success" v-for="item in arrayValue" :key="item" class="mr-1">
          {{ $dict.getText(options, item) }}
        </b-badge>
      </h5>
    </div>
    <multiselect
      v-if="!viewmode"
      v-model="selectValue"
      track-by="value"
      label="text"
      :options="options"
      :multiple="true"
      :searchable="false"
      :close-on-select="true"
      :placeholder="placeholder"
      :hide-selected="true"
      selectLabel=""
      @select="selectedData"
      @remove="removeData"
    >
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect'
import commonValidate from '@/mixins/commonValidate.js'

export default {
  components: { Multiselect },
  mixins: [commonValidate],
  props: {
    id: { type: String, required: true },
    fieldname: { type: String, required: true },
    label: { type: String, default: null, required: false },
    value: { required: true },
    options: { type: Array, required: true },
    placeholder: { type: String, default: '', required: false },
    description: { type: String, default: '', required: false },
    viewmode: { type: Boolean, default: false, required: false },
    validators: { type: Array, defaule: [], required: false },
    disperror: { type: Boolean, default: false, required: false },
    labelCols: { type: Number, default: 3, required: false },
    labelAlign: { type: String, default: 'left', required: false }
  },
  setup (props) {
    let selectValue = null
    let valuesData = []
    const requiredClass = props.validators ? (props.validators.indexOf('required') >= 0 ? 'required' : '') : ''
    return {
      selectValue,
      valuesData,
      requiredClass
    }
  },
  computed: {
    arrayValue () {
      return this.value.split(',')
    },
    multiValue () {
      return this.userId > '0'
    }
  },
  methods: {
    selectedData (selected) {
      this.valuesData.push(selected.value)
      this.updateValue(this.valuesData.join(','))
    },
    removeData (removed) {
      this.valuesData = this.valuesData.filter((rec) => rec !== removed.value)
      this.updateValue(this.valuesData.join(','))
    }
  },
  watch: {
    value (v) {
      if (v === null || v === undefined) {
        this.valuesData = []
      } else {
        this.valuesData = v !== '' ? v.split(',').map(String) : []
      }
      this.selectValue = this.options.filter(rec => this.valuesData.includes(rec.value))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/fields/MultiselectField.vue